<template>
  <div style="margin: 10px; padding: 5px">
    <div>
      <strong>Filter {{ demographicColumnNames[demographicColumn] }} by {{ modeNames[data_table].name }} Time</strong>
    </div>
    <vue-slider
        v-model="value"
        :data="markData"
        :marks="markLabels"
        :lazy="true"
        :tooltip-formatter="tooltip"
        :min-range="1"
        :tooltip-placement="'bottom'"
        style="margin-bottom: 20px"
    ></vue-slider>
  </div>

</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: "TimeSlider",
  props: ['legend', 'data_table', 'modeNames', 'demographicColumn', 'demographicColumnNames'],
  components: {VueSlider},
  data: function () {
    return {
      value: [this.modeNames[this.data_table].breakPoints[0].toString(), '100'],
    }
  },
  methods: {
    tooltip: function (value) {
      let lastbreak = this.modeNames[this.data_table].breakPoints.at(-1)
      if (value === '100') {
        return '>' + lastbreak
      } else
        return value
    }
  },
  computed: {
    markData: function () {
      let marks = this.modeNames[this.data_table].breakPoints.map(b => b.toString())
      marks.push('100')
      return marks
    },
    markLabels: function () {
      let labels = {}
      let lastbreak = this.modeNames[this.data_table].breakPoints.at(-1)
      this.markData.forEach((mark) => {
        if (mark === '100') {
          labels[mark] = '>' + lastbreak
        } else {
          labels[mark] = mark
        }
      })
      return labels
    }
  },
  watch: {
    value: function () {
      this.$emit('time-slider-input', this.value.map(v => parseInt(v, 10)))
    },
    data_table: function () {
      this.value = [this.modeNames[this.data_table].breakPoints[0].toString(), '100']
    }
  }
}
</script>

<style scoped>
</style>